import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';


import { getDesignation, getMysurvey } from '../../store/reducers/actionPermission';
import { ACTIVE_STATUS } from '../../constant/constant';
import { Mysurvey } from '../../constant/tableHeader';

import Loader from '../ReusableComponents/Loader';
import TmMasterTable from '../ReusableComponents/TmMasterTable';
import SearchInput from '../ReusableComponents/SearchInput';
import TmFilter from '../ReusableComponents/TmFilter';
import AntdModalComp from '../ReusableComponents/AntdModalComp';


import SurveyApi from '../../Api/SurveyApi';
import {
  toastError,
  toastSuccess,
  toastWarn,
} from '../Toast/ToastComponent';
import { DeletePopup } from '../ReusableComponents/DeletePopup';

import SurveyCategoryApi from '../../Api/SurveyCategoryApi';
import { useAuth } from '../../Context/AuthContext';

import { SURVEY_COMPLETION } from '../../constant/constant';

let filterArray = [
  {
    options: SURVEY_COMPLETION,
    placeholder: 'Status',
    controlName: 'status',
    input: 'select',
    allowClear: true,
    size: 'small',
    style: { width: 120 },
    col: 2,
  },
  {
    order: 1,
    col: 'auto',
    className: 'ms-auto pe-0',
    input: 'button',
    type: 'dashed',
    htmlType: 'button',
    text: 'Reset',
  },
];

const MySurveyComp = () => {
  const { authState } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  const permission = useSelector(
    getMysurvey
  );
  const userDetails = useSelector((state) => state.auth?.user);
 const hasFetched = useRef(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);

  const [modalHeader, setModalHeader] = useState('');

  const [filterArr, setFilterArr] = useState({
    search: '',
    status: null,
  });
  const filterArrRef = useRef(filterArr);
  const debounceTimeoutRef = useRef(null);

  useEffect(() => {
    filterArrRef.current = filterArr;
  }, [filterArr]);

  const [buttonPermission, setButtonPermissions] = useState({
    add: false,
    edit: false,
    delete: undefined,
    view: false,
  });

  // ============================

  // ============================
  
  const getSurveyList = useCallback(async (filters = {}) => {
    try {
      setLoading(true);
      // const idToPass = userDetails.id || 18;
      const idToPass = authState?.id;
      console.log(idToPass,"userId")
      console.log('🚀 Calling API with user_id:', idToPass);

      const res = await SurveyApi.getMysurveyList({
        user_id: idToPass,
        limit: 100000,
        page: 1,
        search: filters.search || '',
        completion_status: filters.status || ''
      });

      if (res?.data?.success) {
        // Support either paginated format (result.rows) or flat array (result)
        let rows = [];
        if (Array.isArray(res.data.result)) {
          rows = res.data.result;
        } else if (res.data.result?.rows) {
          rows = res.data.result.rows;
        }

        const mappedData = rows.map((survey, index) => ({
          id: survey.id,
          user_id: idToPass,
          serialNo: index + 1,
          title: survey.title || 'Untitled Survey',
          status: survey.activeStatus,
          progress: survey.status,
          is_required: survey.is_required,
          startDate: survey.start_date,
          endDate: survey.end_date,
          user_ids: survey.user_ids || [],
          question: survey.question || [],
          totalQuestions: survey?.question_count || 0,
          departmentsID: '1',
          completion_status: survey.completion_status
        }));

        setData(mappedData);

      } else {
        setData([]);
        toastWarn(res?.data?.message || 'No data found');
      }
    } catch (err) {
   
      toastError('Something went wrong');
    } finally {
      setLoading(false);
    }
  }, [userDetails?.id]);

  // ============================
  // LOAD DATA & PERMISSIONS
  // ============================
  useEffect(() => {
    if (hasFetched.current) return;

  hasFetched.current = true;
    // Check Permissions
    if (permission) {
      if (permission.checked === false) {
        navigate('/');
      } else {
        const obj = {};
        permission.actions.forEach((el) => {
          obj[el.statename.toLowerCase()] = el.checked;
        });
        setButtonPermissions(obj);
      }
    }
    getSurveyList(filterArrRef.current);
  }, [permission, getSurveyList, navigate]);

  // Refresh list after returning from survey submission
  useEffect(() => {
    if (location.state?.submitted) {
      getSurveyList(filterArrRef.current);
      // Clear the state so it doesn't re-trigger
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.submitted]);


  const handleSearchChange = (value) => {
    const trimmed = value;
    setFilterArr((prev) => ({ ...prev, search: trimmed }));

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = setTimeout(() => {
      getSurveyList({ ...filterArrRef.current, search: trimmed });
    }, 400);
  };

  const handleFilterChange = (value) => {
    const newFilter = { ...filterArrRef.current, ...value };
    setFilterArr(newFilter);
    getSurveyList(newFilter);
  };

  const toggleModal = (type, value) => {
    if (type === 'Close') {
      setModal(false);
      return;
    }

    if (type === 'Add') {
      navigate('/my-survey');
      return;
    }

    if ((type === 'Edit' || type === 'View') && value) {
  
      const targetId = value?.id;
      const selectedSurvey = data.find((s) => s.id === targetId);

      if (!selectedSurvey) {
        toastError('Survey ID not found');
        return;
      }


      const allQuestions =
        selectedSurvey.question?.flatMap((qGroup) => qGroup.questions) || [];

      console.log('Authorized! Showing questions:', allQuestions);

 navigate(`/my-survey/${targetId}`, {
  state: { allQuestions, status: selectedSurvey.completion_status },
});
    }
  };

  const callDelete = async (id) => {
    await DeletePopup(async (ok) => {
      if (!ok) return;
      try {
        const res = await SurveyApi.delete(id);
        if (res.data.success) {
          toastSuccess(res.data.message);
          getSurveyList();
        } else {
          toastWarn(res.data.message);
        }
      } catch (err) {
        toastError(err?.message || 'Delete failed');
      }
    });
  };


  return (
    <div>
      <div className="d-md-flex align-items-center mb-2">
        <h5 className="mb-0">My Survey</h5>
        <div className="ms-auto d-flex align-items-center">
          <div className="me-2">
            <SearchInput
              placeholder="Search"
              value={filterArr.search}
              onSearchChange={handleSearchChange}
            />
          </div>
        </div>
      </div>

      <div className="mt-2 mb-2">
        <TmFilter
          filterArray={filterArray}
          handleFilterChange={handleFilterChange}
        />
      </div>

      {loading ? (
        <Loader />
      ) : (
        <TmMasterTable
          buttonPermission={buttonPermission}
          rows={data}
          columns={Mysurvey}
          custom={[]}
          toggleModal={toggleModal}
          handleDelete={callDelete}
        />
      )}

      <AntdModalComp
        width="60%"
        modalOpen={modal}
        toggleModal={() => toggleModal('Close')}
        modalHeader={modalHeader}
      />
    </div>
  );
};
export default MySurveyComp;